var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorNurses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.25,
    height: 53.906,
    viewBox: "0 0 56.25 53.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12927",
    d: "M48.463 49.26H8.619a8.212 8.212 0 0 1-8.2-8.2V17.62a8.212 8.212 0 0 1 8.2-8.2h39.844a8.212 8.212 0 0 1 8.2 8.2v23.437a8.212 8.212 0 0 1-8.2 8.203zM8.619 11.76a5.866 5.866 0 0 0-5.859 5.86v23.437a5.866 5.866 0 0 0 5.859 5.859h39.844a5.866 5.866 0 0 0 5.859-5.859V17.62a5.866 5.866 0 0 0-5.859-5.859z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12928",
    d: "M16.822 53.948H9.791A2.346 2.346 0 0 1 7.447 51.6v-3.512a1.172 1.172 0 0 1 1.172-1.172h9.375a1.172 1.172 0 0 1 1.172 1.172V51.6a2.346 2.346 0 0 1-2.344 2.348zM9.791 49.26v2.34h7.033v-2.34z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12929",
    d: "M48.463 53.948h-7.031a2.346 2.346 0 0 1-2.344-2.348v-3.512a1.172 1.172 0 0 1 1.172-1.172h9.375a1.172 1.172 0 0 1 1.172 1.172V51.6a2.346 2.346 0 0 1-2.344 2.348zm-7.031-4.688v2.34h7.033v-2.34z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12930",
    d: "M42.6 11.76H14.478a1.172 1.172 0 0 1-1.172-1.172V8.245a8.212 8.212 0 0 1 8.2-8.2h14.066a8.212 8.212 0 0 1 8.2 8.2v2.344A1.172 1.172 0 0 1 42.6 11.76zM15.65 9.417h25.781V8.245a5.866 5.866 0 0 0-5.859-5.859H21.51a5.866 5.866 0 0 0-5.86 5.859z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12931",
    d: "M33.228 44.573h-9.375a1.172 1.172 0 0 1-1.171-1.173v-8.2h-8.2a1.172 1.172 0 0 1-1.172-1.172v-9.377a1.172 1.172 0 0 1 1.172-1.172h8.2v-8.2a1.172 1.172 0 0 1 1.171-1.179h9.375a1.172 1.172 0 0 1 1.172 1.176v8.2h8.2a1.172 1.172 0 0 1 1.172 1.172v9.375A1.172 1.172 0 0 1 42.6 35.2h-8.2v8.2a1.172 1.172 0 0 1-1.172 1.173zm-8.2-2.344h7.031v-8.2a1.172 1.172 0 0 1 1.172-1.172h8.2v-7.034h-8.2a1.172 1.172 0 0 1-1.172-1.172v-8.2h-7.034v8.2a1.172 1.172 0 0 1-1.172 1.172h-8.2v7.031h8.2a1.172 1.172 0 0 1 1.172 1.172z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12932",
    d: "M28.541 39.885a1.172 1.172 0 0 1-1.172-1.172v-18.75a1.172 1.172 0 1 1 2.344 0v18.75a1.172 1.172 0 0 1-1.172 1.172z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12933",
    d: "M37.916 30.51h-18.75a1.172 1.172 0 0 1 0-2.344h18.75a1.172 1.172 0 0 1 0 2.344z",
    transform: "translate(-.416 -.042)",
    style: {
      fill: "#d24350"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorNurses);
export default __webpack_public_path__ + "static/media/doctor-nurses.7d952163a09846b8546bee4146150a3b.svg";
export { ForwardRef as ReactComponent };